import { FC, useContext } from "react";

import Dialog from "@mui/material/Dialog";

import { AdminProtected } from "@/components/Application/AdminProtected";
import { EditProcedureForm } from "@/components/Procedures/EditProcedureForm";

import { UserContext } from "@/model/User/UserContext";

export interface EditProcedureModalProps {
	open: boolean;
	onClose: () => void;
	id: number;
}

export const EditProcedureModal: FC<EditProcedureModalProps> = (props) => {
	const { onClose, open, id } = props;

	const handleClose = () => {
		onClose();
	};

	const user = useContext(UserContext);

	return (
		<AdminProtected>
			<Dialog onClose={handleClose} open={open} fullWidth>
				<EditProcedureForm
					user={user}
					handleClose={handleClose}
					open={open}
					id={id}
				/>
			</Dialog>
		</AdminProtected>
	);
};
